<script setup>
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

defineProps({
  documents: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  detailsLabel: { type: String, default: '' },
});
const emit = defineEmits(['download', 'details']);
const { t } = useI18n();

const typeNames = document =>
  (document.document_types || [])
    .map(type => type.name || type.nome)
    .filter(Boolean);
const documentLabel = document =>
  typeNames(document).join(', ') || document.filename;
</script>

<template>
  <LaisCard
    :title="t('POST_SALE.TOPICS.DOCUMENTS.PROPERTY')"
    prefix-icon="i-lucide-building-2"
  >
    <div v-if="loading" class="grid gap-2">
      <div
        v-for="index in 3"
        :key="index"
        class="h-14 animate-pulse rounded-lais-sm bg-lais-bg-soft"
      />
    </div>
    <div v-else class="grid gap-2">
      <article
        v-for="document in documents"
        :key="document.id"
        data-testid="post-sale-analysis-property-document"
        class="flex flex-wrap items-center justify-between gap-3 rounded-lais-sm border border-lais-border-soft p-3"
      >
        <div class="flex min-w-0 items-center gap-2">
          <span
            class="i-lucide-file-text size-5 shrink-0 text-lais-success"
            aria-hidden="true"
          />
          <p class="min-w-0 truncate text-sm font-medium text-lais-text-body">
            {{ documentLabel(document) }}
          </p>
          <span
            v-if="typeNames(document).length > 1"
            class="shrink-0 rounded-full bg-lais-bg-soft px-2 py-1 text-xs font-semibold text-lais-text-body"
          >
            {{
              t('POST_SALE.TOPICS.DOCUMENTS.MORE_TYPES', {
                count: typeNames(document).length,
              })
            }}
          </span>
        </div>
        <LaisPrimaryButton
          v-if="document.download_available"
          data-testid="post-sale-analysis-property-document-view"
          size="sm"
          variant="ghost"
          @click="emit('download', document)"
        >
          {{ t('POST_SALE.TOPICS.ACTIONS.VIEW_DOCUMENT') }}
        </LaisPrimaryButton>
      </article>
    </div>
    <template v-if="detailsLabel" #footer>
      <LaisPrimaryButton
        data-testid="post-sale-analysis-property-details"
        variant="ghost"
        @click="emit('details')"
      >
        {{ detailsLabel }}
      </LaisPrimaryButton>
    </template>
  </LaisCard>
</template>
